export const getStatus = (status) => {
  const statusTextMap = {
    DRAFT: 'Draft',
    SUBMITTED: 'Awaiting Approval',
    AUTHORISED: 'Awaiting Payment',
    PAID: 'Paid',
    DELETED: 'Deleted',
    VOIDED: 'Voided',
    BILLED: 'Billed',
  };

  return statusTextMap[status] || status;
};

export const getType = (type) => {
  const statusTextMap = {
    "ACCRECCREDIT": 'Receivable Credit',
    "ACCPAYCREDIT": 'Payable Credit',
    "RECEIVE-OVERPAYMENT": "Recieve Overpayment",
    "SPEND-OVERPAYMENT": "Spend Overpayment",
  };

  return statusTextMap[type] || type;
};

export const getTax = (type) => {
  const taxMap = {
    NoTax: 'No Tax',
    Exclusive: 'Tax Exclusive',
    Inclusive: 'Tax Inclusive',
  };

  return taxMap[type] || type;
};

